import PropTypes from 'prop-types';
import {Translate} from 'react-redux-i18n';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import {CountryFlag} from 'front-onceforall-core';

function DossierCountrySelectorView(props) {
  const countryItems = props.countries.map(country => (
    <MenuItem
      key={`country-${country}`}
      value={country}
    >
      <span className="flex-container pt-1">
        <CountryFlag
          country={country}
          size={15}
        />
        {!props.minimalist && <Translate value={`country.${country}`}/>}
      </span>
    </MenuItem>
  ));

  return (
    <div>
      <TextField
        data-id="dossier-country-selector"
        select
        disabled={props.disabled}
        value={props.value}
        onChange={props.onChange}
        size="small"
        label={!props.minimalist && <Translate value="dossier.countryLabel"/>}
        variant={props.minimalist ? 'standard' : 'outlined'}
        InputProps={props.minimalist ? {disableUnderline: true} : {}}
      >
        {countryItems}
      </TextField>
    </div>
  );
}

DossierCountrySelectorView.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  countries: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  disabled: PropTypes.bool,
  minimalist: PropTypes.bool
};

export default DossierCountrySelectorView;
